import { useId, type ReactNode } from 'react'

export interface FieldProps {
  label: string
  /** the control; receives the id to label it */
  children: (id: string) => ReactNode
  help?: string
  error?: string | undefined
  required?: boolean
  className?: string
}

/** Label + control + help + error, in the kit's spacing. Every control gets a real <label>. */
export function Field({ label, children, help, error, required, className = '' }: FieldProps) {
  const id = useId()
  return (
    <div className={`mb-3 ${className}`}>
      <label htmlFor={id} className="label">
        {label}
        {required && <span className="ml-0.5 text-red-500">*</span>}
      </label>
      {children(id)}
      {error ? <p className="field-error">{error}</p> : help ? <p className="help">{help}</p> : null}
    </div>
  )
}
